export const tryParseJSON = (json: string, defaultValue: any = undefined) => {
  try {
    return JSON.parse(json)
  } catch {
    return defaultValue
  }
}
